import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { PlotPortfolioSubscription } from '@/api/rest/resources/types/plotPortfolioSubscriptions';

type ViewPlotPortfolioSubscriptionDialogProps = {
  plotPortfolioSubscription: PlotPortfolioSubscription | null;
  onClose: () => void;
};

export const ViewPlotPortfolioSubscriptionDialog = ({
  plotPortfolioSubscription,
  onClose,
}: ViewPlotPortfolioSubscriptionDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={!!plotPortfolioSubscription} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent data-testid='view-plot-portfolio-subscription-dialog'>
        <DialogHeader>
          <DialogTitle>{t('shared.ndiOrganizationSubscriptions.viewPlotPortfolioDialog.title')}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {plotPortfolioSubscription && (
            <Stack spacing={4}>
              <ReadOnlyField
                label={t('shared.ndiOrganizationSubscriptions.fields.product')}
                value={plotPortfolioSubscription.plot_portfolio_product_name}
              />
              <ReadOnlyField
                label={t('shared.ndiOrganizationSubscriptions.fields.displayName')}
                value={plotPortfolioSubscription.display_name}
              />
              <ReadOnlyField
                label={t('shared.ndiOrganizationSubscriptions.fields.startDate')}
                value={new Date(plotPortfolioSubscription.start_date).toLocaleDateString()}
              />
              <ReadOnlyField
                label={t('shared.ndiOrganizationSubscriptions.fields.endDate')}
                value={new Date(plotPortfolioSubscription.end_date).toLocaleDateString()}
              />
              <ReadOnlyField
                label={t('shared.ndiProducts.fields.initialSetupCostCredits')}
                value={String(plotPortfolioSubscription.initial_setup_cost_credits)}
              />
              <ReadOnlyField
                label={t('shared.ndiProducts.fields.plotCreationCostCredits')}
                value={String(plotPortfolioSubscription.plot_creation_cost_credits)}
              />
              <ReadOnlyField
                label={t('shared.ndiProducts.fields.maxPlots')}
                value={plotPortfolioSubscription.max_plots?.toString() ?? t('shared.ndiProducts.noLimit')}
              />
              <ReadOnlyField
                label={t('shared.ndiProducts.fields.maxHectares')}
                value={plotPortfolioSubscription.max_hectares?.toString() ?? t('shared.ndiProducts.noLimit')}
              />
            </Stack>
          )}
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};

const ReadOnlyField = ({ label, value }: { label: string; value: string }) => (
  <Stack spacing={1}>
    <span className='typography-caption text-text-secondary'>{label}</span>
    <span className='typography-body1'>{value}</span>
  </Stack>
);
